var map = {
	"./british-flag.svg": 15,
	"./cookie-croque.svg": 40,
	"./icon-deselect.svg": 49,
	"./profile-preview-large.svg": 50,
	"./qr-white.svg": 41,
	"./qrcode-big.svg": 26,
	"./squares-orange.svg": 70,
	"./squares-white.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;